const Mobile = ({ title, description, handleShow }) => {
    return (
        <div class="accordion mbl_" id='accordions'>
            <div class="accordion-item">
                <h2 class={`accordion-header active`} id={`heading0`}>
                    <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse0`}
                        aria-expanded={'true'}
                        aria-controls={`collapse0`}
                    >{title}</button>
                </h2>
                <div id={`#collapse0`}
                    class={`accordion-collapse collapse show`}
                    aria-labelledby={`heading0`}
                    data-bs-parent="#accordions"
                >
                    <div class="accordion-body">
                        <p>{description}</p>
                        <div className="text-center">
                            <a onClick={handleShow}>Learn more</a>
                            <button>Join Discord <i className="fa-solid fa-chevron-right"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Mobile